import { createTheme } from "@mui/material/styles"
import colors from "./colors"

// custom theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
      dark: colors.darkPrimary,
    },
    secondary: {
      main: colors.cyan,
    },
    error: {
      main: colors.red,
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid rgba(0, 0, 0, 0.06)",
          boxShadow:
            "0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow:
              "0 12px 24px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0, 0, 0, 0.04)",
            borderColor: "rgba(0, 0, 0, 0.08)",
          },
        },
      },
    },
  },
})

export default theme
